import { info_tab, preview_tab } from '../../../../../../views/contract/template';

export default {
  title: 'Modèle de contrat',
  tabs: {
    [info_tab]: 'Infos',
    [preview_tab]: 'Aperçu',
  },
  sections: {
    subscription: 'Abonnement',
    setup_cost: 'Frais de mise en place',
    preview: 'Aperçu',
  },
  form: {
    has_trial: {
      label: "Ajouter des jours d'essai",
    },
    trial_days: {
      label: "Jours d'essai gratuits",
      placeholder: '7',
      validation: {
        required: "Les jours d'essai sont requis",
        min: "{{value}} est la valeur minimale pour les jours d'essai",
      },
    },
  },
  buttons: {
    apply: 'Appliquer les modifications',
    download: 'Télécharger',
    apply_changes: 'Appliquer les modifications',
  },
  files: {
    contract: '{{provider}}-contract-template-{{company}}.pdf',
  },
  toasts: {
    failed_to_load_data: "Échec du chargement de l'aperçu",
  },
};
